<template>
  <div>
    <v-text-field v-model="name" label="نام فروشگاه" outlined dense class="mb-4" @input="validate"/>
    <v-textarea v-model="description" label="توضیحات" outlined dense rows="2"/>
  </div>
</template>
<script>
export default {
  data: () => ({ name: "", description: "" }),
  methods: {
    validate() { this.$emit("valid", !!this.name.trim()); },
    getData() { return { name: this.name, description: this.description }; }
  }
};
</script>
